// TEMPORARY (2026-10-29): the experience backlog page's calls (routes/experience-backlog.routes.js).
import { api } from '@/lib/api.js';

export function getExperienceBacklog() {
  return api.get('/api/tracon/experience-backlog');
}
export function buildExperienceBacklog() {
  return api.post('/api/tracon/experience-backlog/build', {});
}
export function recheckExperienceSession(sessionId) {
  return api.post(`/api/tracon/experience-backlog/${encodeURIComponent(sessionId)}/recheck`, {});
}
